import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CheckCircle2Icon, GiftIcon } from 'lucide-react';
import { PreviewCarousel } from './PreviewCarousel';
import { bonuses, capabilities, volumes } from '../data/offer';
import type { Volume } from '../types/content';
const accentStyles: Record<Volume['accent'], {
  border: string;
  text: string;
}> = {
  info: {
    border: 'border-info/30',
    text: 'text-info'
  },
  primary: {
    border: 'border-primary-soft/30',
    text: 'text-primary-soft'
  },
  highlight: {
    border: 'border-highlight/30',
    text: 'text-highlight'
  },
  danger: {
    border: 'border-danger-soft/30',
    text: 'text-danger-soft'
  }
};
export function ProductOffer() {
  return <>
      <section className="bg-surface px-4 py-16 sm:py-24" data-id="element-154" data-mp="ugxh5jwq0ua1">
        <div className="mx-auto max-w-5xl" data-id="element-155" data-mp="fin1hk1e57in">
          <header className="text-center" data-id="element-156" data-mp="fjx14dnw6nre">
            <h2 className="font-display text-3xl font-bold text-highlight sm:text-5xl" data-id="element-157" data-mp="khyj0v9l0h1a">
              🏆 PACK COMIDAS RESUELTAS™
            </h2>
            <p className="mx-auto mt-4 max-w-4xl text-lg font-medium" data-id="element-158" data-mp="3ldhzy17nsk4g">
              Tu sistema en 4 volúmenes para planificar, preparar y congelar tus comidas, y tenerlas listas para usar durante la semana.
            </p>
          </header>

          <div className="mt-10 rounded-2xl border border-primary/30 bg-primary/10 p-6 sm:p-8" data-id="element-159" data-mp="3qe60pelowfbv">
            <h3 className="text-center font-display text-xl font-bold" data-id="element-160" data-mp="32ol781rwtzoc">
              CON ESTE SISTEMA VAS A PODER:
            </h3>
            <div className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-161" data-mp="2xq9yxvh9jx88">
              {capabilities.map(item => <p key={item} className="flex gap-2 text-foreground-soft" data-id="element-162" data-mp="3bhexeu8wajgz">
                  <CheckCircle2Icon className="h-5 w-5 shrink-0 text-primary-soft" aria-hidden="true" data-id="element-163" data-mp="36q6sobiifma5" />
                  {item}
                </p>)}
            </div>
          </div>

          <h3 className="mt-12 text-center font-display text-2xl font-bold" data-id="element-164" data-mp="2iyhre5npnnh2">
            📚 4 VOLÚMENES COMPLETOS
          </h3>
          <div className="mt-7 space-y-5" data-id="element-165" data-mp="hymko4wmefmo">
            {volumes.map((volume, index) => {
            const accent = accentStyles[volume.accent];
            return <motion.article key={volume.title} initial={{
              opacity: 0,
              y: 16
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.06
            }} className={`flex gap-5 rounded-2xl border ${accent.border} bg-canvas p-5 sm:p-7`} data-id="element-166" data-mp="mvmu8psoi0ij" data-mpi={index}>
                  <BookOpenIcon className={`mt-1 h-7 w-7 shrink-0 ${accent.text}`} aria-hidden="true" data-id="element-167" data-mp="3z3omah32uqq" />
                  <div className="flex-1" data-id="element-168" data-mp="8wdf7tg7lcg5">
                    <p className={`text-xs font-bold tracking-brand ${accent.text}`} data-id="element-169" data-mp="dwhtdctn9v37">
                      {volume.label}
                    </p>
                    <h4 className="mt-1 font-display text-lg font-bold sm:text-xl" data-id="element-170" data-mp="1kcbqm3yv0akj">
                      {volume.title}
                    </h4>
                    <p className="mt-1 text-sm text-foreground-subtle sm:text-base" data-id="element-171" data-mp="39tpfzkc2mcvs">
                      {volume.subtitle}
                    </p>
                    <ul className="mt-4 space-y-2" data-id="element-172" data-mp="34ve659ls02dk">
                      {volume.items.map(item => <li key={item} className="flex gap-2 text-sm leading-relaxed text-foreground-muted sm:text-base" data-id="element-173" data-mp="3034b5f5t0c4f">
                          <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-primary-soft" aria-hidden="true" data-id="element-174" data-mp="2v4jhjyl24qoy" />
                          {item}
                        </li>)}
                    </ul>
                    <p className="mt-5 border-t border-foreground/10 pt-4 text-sm sm:text-base" data-id="element-175" data-mp="2m337xt22gsls">
                      <span className="font-semibold text-foreground-subtle" data-id="element-176" data-mp="2h5jwt20o0vy2">Resultado: </span>
                      <span className={`font-bold italic ${accent.text}`} data-id="element-177" data-mp="2c7rvxii1lzhq">{volume.result}</span>
                    </p>
                  </div>
                </motion.article>;
          })}
          </div>
        </div>
      </section>

      <PreviewCarousel data-id="element-178" data-mp="ad0va41x2gn7" />

      <section className="bg-canvas px-4 py-16 sm:py-24" data-id="element-179" data-mp="346ae8y7qth53">
        <div className="mx-auto max-w-5xl" data-id="element-180" data-mp="344pg6ym7zg2h">
          <header className="text-center" data-id="element-181" data-mp="388ovjdvrk8u9">
            <GiftIcon className="mx-auto h-10 w-10 text-highlight" aria-hidden="true" data-id="element-182" data-mp="387m331islyc8" />
            <h2 className="mt-3 font-display text-3xl font-bold text-highlight sm:text-5xl" data-id="element-183" data-mp="2u84aeb2dm0xl">
              Y ADEMÁS, TE LLEVÁS 5 BONOS
            </h2>
          </header>
          <div className="mt-10 space-y-4" data-id="element-184" data-mp="2kikpkzv3rx03">
            {bonuses.map(({
            number,
            title,
            detail,
            items,
            value
          }) => <article key={number} className="flex flex-col gap-4 rounded-2xl border border-highlight/20 bg-surface p-5 sm:flex-row sm:items-start sm:p-7" data-id="element-185" data-mp="2bieibvpzzt9d">
                <span className="w-fit whitespace-nowrap rounded-lg bg-highlight/10 px-3 py-2 font-bold text-highlight" data-id="element-186" data-mp="2ghr6qkwip8e2">
                  🎁 BONO {number}
                </span>
                <div className="flex-1" data-id="element-187" data-mp="26i0b2fw80nce">
                  <h3 className="font-bold" data-id="element-188" data-mp="26kw7fzsf73yq">{title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-muted" data-id="element-189" data-mp="1myb727krpfh0">
                    {detail}
                  </p>
                  <ul className="mt-3 space-y-1.5" data-id="element-190" data-mp="1ixrab543wdve">
                    {items.map(item => <li key={item} className="flex gap-2 text-sm leading-relaxed text-foreground-muted" data-id="element-191" data-mp="1ww8uwtypta93">
                        <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-highlight" aria-hidden="true" data-id="element-192" data-mp="1rurut0o21rtk" />
                        {item}
                      </li>)}
                  </ul>
                </div>
                <div className="flex shrink-0 items-center gap-3" data-id="element-193" data-mp="21sg0umr42lr1">
                  <span className="text-xs font-semibold text-foreground-faint" data-id="element-194" data-mp="2fkm458960y92">VALOR:</span>
                  <span className="text-sm text-foreground-faint line-through" data-id="element-195" data-mp="2anvp8o93k8p8">
                    {value}
                  </span>
                  <span className="rounded-full bg-primary-soft px-3 py-1 text-sm font-bold text-canvas" data-id="element-196" data-mp="2pi0jt5n9lj0b">
                    GRATIS
                  </span>
                </div>
              </article>)}
          </div>
          <div className="mt-8 rounded-2xl border border-highlight/30 bg-highlight/10 p-6 text-center" data-id="element-197" data-mp="2rmdqo7ip6ib5">
            <p className="text-xs font-bold tracking-brand text-highlight" data-id="element-198" data-mp="31mecc041haii">
              VALOR TOTAL BONOS
            </p>
            <p className="mt-1 text-2xl font-bold text-foreground-subtle line-through" data-id="element-199" data-mp="36dmh2iufc7pc">
              $52.000
            </p>
            <p className="mt-2 font-display text-xl font-bold text-highlight" data-id="element-200" data-mp="3bbfpzjn43ftb">
              GRATIS con tu Pack Comidas Resueltas™
            </p>
          </div>
        </div>
      </section>
    </>;
}